module.exports = __webpack_public_path__ + "img/03.ee78c989.jpg";